import { Box } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BottomSheetIllustrationContent } from "@src/appV2/redesign/system/ui-components";

interface TimekeepingActionSuccessContentProps {
  title: string;
  description?: string;
  onClose: () => void;
}

export function TimekeepingActionSuccessContent(props: TimekeepingActionSuccessContentProps) {
  const { title, description, onClose } = props;

  return (
    <Box>
      <BottomSheetIllustrationContent
        hasFooter
        illustrationType="clock"
        title={title}
        description={description}
      />
      <DialogFooter orientation="vertical" closeButtonAriaLabel="Close" onClose={onClose} />
    </Box>
  );
}
